import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2240fd75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app__header__title" }
const _hoisted_2 = { class: "app__title" }
const _hoisted_3 = {
  key: 0,
  id: "description"
}
const _hoisted_4 = { class: "primary__dark__color hotel-characteristics__title" }
const _hoisted_5 = { class: "gray__base__color hotel__description" }
const _hoisted_6 = {
  key: 1,
  id: "address"
}
const _hoisted_7 = { class: "primary__dark__color hotel-characteristics__title" }
const _hoisted_8 = { class: "gray__base__color" }
const _hoisted_9 = {
  key: 2,
  id: "commodities"
}
const _hoisted_10 = { class: "primary__dark__color hotel-characteristics__title mb" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color commoditties__icon" }, "add_box")
], -1))
const _hoisted_12 = { class: "commoditties__align" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color commoditties__icon" }, "wifi")
], -1))
const _hoisted_14 = { class: "commoditties__align" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color commoditties__icon" }, "waves")
], -1))
const _hoisted_16 = { class: "commoditties__align" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color commoditties__icon" }, "restaurant")
], -1))
const _hoisted_18 = { class: "commoditties__align" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color commoditties__icon" }, "fitness_center")
], -1))
const _hoisted_20 = { class: "commoditties__align" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commoditties__align" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color commoditties__icon" }, "local_parking")
], -1))
const _hoisted_22 = { class: "commoditties__align" }
const _hoisted_23 = { id: "rules" }
const _hoisted_24 = { class: "primary__dark__color hotel-characteristics__title" }
const _hoisted_25 = { class: "df gray__base__color" }
const _hoisted_26 = { class: "hotel__rules" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2:00 pm", -1))
const _hoisted_28 = { class: "df gray__base__color" }
const _hoisted_29 = { class: "hotel__rules" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "12:00 pm", -1))
const _hoisted_31 = { class: "primary__dark__color hotel-characteristics__title" }
const _hoisted_32 = { class: "room-picture__container" }
const _hoisted_33 = { class: "primary__color hotel-characteristics__title" }
const _hoisted_34 = { class: "hotel__rooms-link" }
const _hoisted_35 = { class: "hotel__rooms-hotel black__base__color" }
const _hoisted_36 = { class: "hotel__hotel-link primary__color" }
const _hoisted_37 = { id: "roomDetails" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons gray__base__color room__icon" }, "hotel")
], -1))
const _hoisted_39 = { class: "room__text gray__base__color" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon gray__base__color" }, "people")
], -1))
const _hoisted_41 = { class: "room__text gray__base__color" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons room__icon gray__base__color" }, "face")
], -1))
const _hoisted_43 = { class: "room__text gray__base__color" }
const _hoisted_44 = { class: "hotel__rooms-link text--center" }
const _hoisted_45 = { class: "hotel__hotel-from gray__base__color" }
const _hoisted_46 = { class: "hotel__price primary__dark__color" }
const _hoisted_47 = { class: "hotel__currency primary__dark__color" }
const _hoisted_48 = { class: "primary__dark__color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_CoronaRoomFilter = _resolveComponent("CoronaRoomFilter")!

  return (_ctx.hotelDetails)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.filterBodyContainerClasses)
      }, [
        _createVNode(_component_el_row, {
          class: _normalizeClass(_ctx.filterOverflowHiddenClasses),
          justify: "end",
          gutter: 20
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 14,
              lg: 16,
              xl: 18
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  gutter: 20,
                  class: "container__position"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24,
                      id: "hotelName"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("hotels.hotelBooking")), 1),
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.hotelDetails.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_carousel, {
                            interval: 5000,
                            class: "hotel__carousel__details",
                            "indicator-position": "none"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotelDetails.pictures, (picture, index) => {
                                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_image, {
                                      src: picture,
                                      style: {"width":"100%"}
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24
                    }, {
                      default: _withCtx(() => [
                        (_ctx.hotelDetails.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("hotels.hotelDescription")), 1),
                              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.hotelDetails.description), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hotelDetails.address)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("hotels.hotelAddress")), 1),
                              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.hotelDetails.address), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hotelDetails && _ctx.roomCommodities)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_el_row, { gutter: 20 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    xs: 24,
                                    sm: 24,
                                    md: 24,
                                    lg: 24,
                                    xl: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("hotels.hotelCommodities")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.roomCommodities && _ctx.roomCommodities.allInclusive)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 0,
                                        class: "pt gray__base__color",
                                        xs: 24,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _hoisted_11,
                                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("hotels.allInclusive")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.roomCommodities && _ctx.roomCommodities.freeWifi)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 1,
                                        class: "pt gray__base__color",
                                        xs: 24,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _hoisted_13,
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("hotels.freeWifi")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.roomCommodities && _ctx.roomCommodities.airConditioning)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 2,
                                        class: "pt gray__base__color",
                                        xs: 24,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _hoisted_15,
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("hotels.airConditioning")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (
                    _ctx.roomCommodities && _ctx.roomCommodities.complimentaryBreakfast
                  )
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 3,
                                        class: "pt gray__base__color",
                                        xs: 24,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _hoisted_17,
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("hotels.complimentaryBreakfast")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.roomCommodities && _ctx.roomCommodities.fitnessCenter)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 4,
                                        class: "pt gray__base__color",
                                        xs: 24,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _hoisted_19,
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("hotels.fitnessCenter")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.roomCommodities && _ctx.roomCommodities.parking)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 5,
                                        class: "pt gray__base__color",
                                        xs: 24,
                                        sm: 12,
                                        md: 6,
                                        lg: 6,
                                        xl: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            _hoisted_21,
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("hotels.parking")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t("hotels.rules")), 1),
                          _createElementVNode("p", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("hotels.checkIn")), 1),
                            _hoisted_27
                          ]),
                          _createElementVNode("p", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("hotels.checkOut")), 1),
                            _hoisted_30
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      xs: 24,
                      sm: 24,
                      md: 24,
                      lg: 24,
                      xl: 24,
                      id: "rooms"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t("hotels.rooms")), 1)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotelDetails.rooms, (room, index) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        xs: 24,
                        sm: 24,
                        md: 8,
                        lg: 6,
                        xl: 6,
                        key: room.id + index,
                        id: "roomsCarousel"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, { class: "hotel__rooms-container" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_el_carousel, { class: "room__carousel" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(room.pictures, (picture, index) => {
                                      return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            src: picture,
                                            class: "room-picture__img"
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("h3", _hoisted_33, _toDisplayString(room.roomName), 1),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("hotels.hotel")) + ":", 1),
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.hotelDetails.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_el_row, {
                                  guter: 24,
                                  class: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _hoisted_38,
                                        _createElementVNode("p", _hoisted_39, _toDisplayString(room.roomType), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _hoisted_40,
                                        _createElementVNode("p", _hoisted_41, " x" + _toDisplayString(room.roomCapacityAdults), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _hoisted_42,
                                        _createElementVNode("p", _hoisted_43, " x" + _toDisplayString(room.roomCapacitychildren), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("hotels.from")), 1),
                                _createElementVNode("span", _hoisted_46, "$" + _toDisplayString(room.amount), 1),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(room.typeCurrency), 1),
                                _createElementVNode("span", _hoisted_48, "/" + _toDisplayString(_ctx.$t("hotels.night")), 1)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 12,
              md: 10,
              lg: 8,
              xl: 6,
              class: _normalizeClass(_ctx.filerRoomFilterClasses)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CoronaRoomFilter, { hotelDetails: _ctx.hotelDetails }, null, 8, ["hotelDetails"])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }, 8, ["class"])
      ], 2))
    : _createCommentVNode("", true)
}